import type { ComponentProps } from "react";
import { type ReactNode } from "react";
import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

import { SubmissionButton } from "@thalamos/frontend";
import type { TranslationKey } from "@thalamos/vision-common";

export type FooterProps = {
  onCancel: {
    label?: TranslationKey;
    color?: ComponentProps<typeof Button>["color"];
    handler: () => void;
  };
  onNext: { label?: TranslationKey; handler?: () => Promise<void> };
  children?: ReactNode;
};

export const Footer = (props: FooterProps) => (
  <FooterInner type={"loaded"} {...props} />
);

///

export const FooterSkeleton = () => <FooterInner type={"loading"} />;

///

type FooterInnerProps =
  | { type: "loading" }
  | ({ type: "loaded" } & FooterProps);

const FooterInner = (props: FooterInnerProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
      }}
    >
      <Button
        variant={props.type === "loading" ? "contained" : "outlined"}
        color={
          (props.type === "loaded" ? props.onCancel.color : undefined) ??
          "primary"
        }
        disabled={props.type === "loading"}
        onClick={props.type === "loading" ? undefined : props.onCancel.handler}
        data-testid="formButton-cancel"
      >
        {t(
          (props.type === "loaded" ? props.onCancel.label : undefined) ??
            "multiPageForm.cancel",
        )}
      </Button>
      {props.type === "loaded" ? props.children : undefined}
      <SubmissionButton
        variant="contained"
        disabled={
          props.type === "loading" || props.onNext.handler === undefined
        }
        onClick={props.type === "loading" ? undefined : props.onNext.handler}
        data-testid="formButton-next"
      >
        {t(
          (props.type === "loaded" ? props.onNext.label : undefined) ??
            "multiPageForm.next",
        )}
      </SubmissionButton>
    </Box>
  );
};
